module.exports = __webpack_public_path__ + "img/study.fc641b27.png";